<template lang="html">

  <section class="card-evenement">
    <div class="card">
        <router-link :to="'/minisite/' + evenementId">
            <img class="card-img-top img-event" :src="image" alt="">
        </router-link>
        <span class="card-caption">en cours</span>
        <div class="card-body">
            <div class="row">
                <div class="col-md-2 pr-0">
                    <span class="date">{{moisAjuste}} <br> {{jour}}</span>
                </div>
                <div class="col-md-10">
                    <router-link :to="'/minisite/' + evenementId">
                        <h5 class="title">{{titreAjuste}}</h5>
                    </router-link>
                    <p class="datetime">{{date}}</p>
                    <p class="place">{{lieu}}</p>
                </div>
            </div>
        </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'card-evenement',
    props: [
      'titre',
      'lieu',
      'date',
      'mois',
      'jour',
      'image',
      'evenementId'
    ],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
        titreAjuste : function(){
            if(this.titre.length > 15){
                return (this.titre.substring(0, 15) + '...');
            }

            return this.titre;
        },
        moisAjuste : function(){
            if(this.mois.length > 3){
                return (this.mois.substring(0, 3));
            }

            return this.mois;
        }
    }
}
</script>

<style>
    .img-event {
        object-fit: cover;
        height: 15em;
    }
</style>
